"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteOptions = void 0;
var AutocompleteCore_1 = __importDefault(require("./AutocompleteCore"));
var Options_1 = require("./Options");
Object.defineProperty(exports, "AutocompleteOptions", { enumerable: true, get: function () { return Options_1.AutocompleteOptions; } });
exports.default = AutocompleteCore_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSx3RUFBa0Q7QUFDbEQscUNBQWdEO0FBR3ZDLG9HQUhBLDZCQUFtQixPQUdBO0FBRDVCLGtCQUFlLDBCQUFnQixDQUFDIn0=